export const part = (state) => state.part //eslint-disable-line
